import clientAxios from "../config";

const makeGift = async (token, data) => clientAxios.post(`/api/gifts`, data, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});

const getActiveGifts = async (token) => clientAxios(`/api/gifts-active`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});

/**
 * Conteo barato de regalos activos sin reclamar para el usuario auth.
 * Pensado para el polling del badge de la campana — no trae la lista,
 * solo `{ count }`.
 */
const getActiveGiftsCount = async (token) => clientAxios(`/api/gifts-active/count`, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});

const registerGift = async (token, data) => clientAxios.post(`/api/gifts-claimed`, data, {
    headers: {
        Authorization: `Bearer ${token}`
    }
});

export {
    makeGift,
    getActiveGifts,
    getActiveGiftsCount,
    registerGift,
}
